import { Api } from './api';
import messages from './messages';

// main validator
export const required = (value) => {
  return value ? undefined : 'required';
};

export const requiredRadioButton = (value) => {
  if (typeof value === 'number' && value !== undefined) return;
  return value ? undefined : 'required';
};

export const mahallaRequired = (value) => {
  if (value && value instanceof Object) return value.value === '' && 'required';
  return !value && 'required';
};

export const asyncValidate = (value) => {
  // console.log(value, value.toJS().captcha);
  const val = value.toJS().captcha;
  return Api.checkCaptcha(val).then((resp) => {
    if (!JSON.parse(resp.body).valid) {
      // console.log('response', resp);
      return { captcha: messages.captchaError };
    }
  });
};

export const validateFile = (value) => {
  if (value && value.size > 10485760) {
    // if more than 10 mb
    return messages.fileError;
  } else if (value && value.type === 'application/x-msdownload') {
    // something.exe
    return messages.fileError2;
  }
};

export const validatePhone = (value) => {
  if (!value) return;
  const ptr = /^(\+|)(998|)(\d{9})$/g;
  return ptr.test(value) ? undefined : messages.phoneError;
};

export const validateYearX = (value) => {
  const ptr = /^([Xx]{2}\.[Xx]{2}|(0[1-9]|[12]\d|3[01])\.(0[1-9]|1[0-2])){1}\.\d{4}$/g;
  return ptr.test(value) ? undefined : messages.yearError;
};

export const validateYear0 = (value) => {
  const ptr = /^([0]{2}\.[0]{2}|(0[1-9]|[12]\d|3[01])\.(0[1-9]|1[0-2])){1}\.\d{4}$/g;
  return ptr.test(value) ? undefined : messages.yearError;
};

export const validateEmail = (value) => {
  if (!value) return undefined;
  const ptr = /^[\w.-]+@\w+\.\w+$/g;
  return ptr.test(value) ? undefined : messages.emailError;
};

export const validatePassportSeries = (value) => {
  if (!/[A-Z]{2}/.test(value.toUpperCase())) return 'required';
  return value.length === 2 ? undefined : 'required';
};

export const validatePassportNum = (value) => {
  return value.length === 7 ? undefined : 'required';
};

export const validateTin = (value) => {
  const ptr = /^\d{9}$/;
  return ptr.test(value) ? undefined : 'required';
};

export const validateAddress = (value) => {
  return value.length <= 255 ? undefined : messages.address_length;
};

export const validateCollectionMembersCount = (value) => {
  const ptr = /^(?:[2-9]|\d{2,})$/;
  return ptr.test(value) ? undefined : messages.collection_members_count_error;
};



// WEBPACK FOOTER //
// ./src/application-form/validators.js